// extracted by mini-css-extract-plugin
export var readonly = "_gs-1";
export var star = "_gs-0";